import { render, staticRenderFns } from "./Customer.vue?vue&type=template&id=d0afc2d6&scoped=true&"
import script from "./Customer.vue?vue&type=script&lang=ts&"
export * from "./Customer.vue?vue&type=script&lang=ts&"
import style0 from "./Customer.vue?vue&type=style&index=0&id=d0afc2d6&prod&lang=scss&scoped=true&"
import style1 from "./Customer.vue?vue&type=style&index=1&id=d0afc2d6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0afc2d6",
  null
  
)

export default component.exports